import { startGame } from '@sl/base/main';
import { Scene } from '@sl/base/scene';
import { Bonus } from '@sl/games/untold_treasures/bonus';
import { Payline } from '@sl/base/logic/payline';
import { Winning } from '@sl/base/logic/winning';

class GameScene extends Scene {
    update() {
        super.update();
    }

    init() {
        super.init();

        this.letInitialize(() => {
            this.shiningPos = {
                'portrait':[
                    {'x':710, 'y':760},
                    {'x':40, 'y':1240},
                    {'x':350, 'y':1045},
                    {'x':700, 'y':980},
                    {'x':276, 'y':792},
                    {'x':150, 'y':1240},
                    {'x':150, 'y':1240},
                    {'x':630, 'y':1030},
                    {'x':80, 'y':1580},
                    {'x':156, 'y':1180},
                    {'x':30, 'y':1150}
                ],
                'landscape':[
                    {'x':88, 'y':451},
                    {'x':258, 'y':690},
                    {'x':897, 'y':732},
                    {'x':1230, 'y':450},
                    {'x':36, 'y':409},
                    {'x':1220, 'y':350},
                    {'x':855, 'y':675},
                    {'x':190, 'y':375},
                    {'x':820, 'y':730},
                    {'x':260, 'y':600},
                    {'x':220, 'y':425}
                ]
            }

            this.winTable = undefined;
            this.winText = undefined;
            this.amountWonStep = 15;
            this.amountWonTimeout = 40;
            this.amountWonFadeInSpeed = 300;

            this.positionerContainer = this.add.container();
            this.createBg();

            this.slots.symbolWidth = 130;
            this.slots.symbolHeight = 170;
            this.slots.spinningRowsCount = 6;
            this.slots.symbolsOffsetLeft = 100;
            this.slots.visibleRowsCount = 3;
            this.slots.frameMaskOffset = 30;
            this.slots.reelsOffsetTop = 360;
            this.slots.symbolBlurFrame = 25;
            this.slots.frameTopOffset = -25;
            this.slots.frameLeftOffset = 0;
            this.slots.spaceBetweenReels = 28;
            this.slots.symbolsFade = 'symbols_fade';
            this.slots.reelBackgroundHorizontalPadding = 18.5;
            this.slots.overspinSound = this.sound.add('overspin', {"loop":false, "volume": 1});

            this.slots.createSlotMachine();
            this.addGameLogo();
            this.addSymbolsAnimations();

            this.bonus = new Bonus(this);
            this.payline = new Payline(this);
            this.winning = new Winning(this);

            this.payline.drawPaylines();

            this.spinSound = this.sound.add('spin', {"loop":true, "volume": 1});

            this.createWinningsContainer();
            this.spritesReady = true;
            this.baseGamePositioner();
        });
    }

    afterPurchase() {
        this.winning.removeTimers();
        this.slots.spin();
    }

    afterStep() {
        const { scenario } = this.request;
        
        if (scenario) {
            if(!this.skip && scenario.freespins && parseInt(scenario.freespins.current) === 1) {
                this.bonus.init(() => {
                    this.afterPurchase();
                });
            } else {
                if (scenario.reels) {
                    this.afterPurchase();
                } 
            }

            return;
        }

        if(this.request.previousScenario && this.request.previousScenario.freespins) {
            this.bonus.after(() => {
                this.request.spinFinished();
            });

            return;
        }

        this.request.spinFinished();
    }

    createWinningsContainer() {
        this.winningsContainer = this.add.container();
        this.winningsContainer.alpha = 0;
    }

    createBg() {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 0);
        this.positionerContainer.add(this.bg);
        
        this.torch = this.add.sprite(180, -20, 'torch').setOrigin(0.5, 0.5);
        
        this.anims.create({
            key: 'torch',
            frameRate: 24,
            yoyo: 0,
            repeat: -1,
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('torch', {
                start: 0,
                end: 49,
            }),
        });

        this.anims.play('torch', this.torch);

        this.createShining();

    }

    createShining() {
        this.shiningContainer = this.add.container();

        this.time.addEvent({
            delay: 500,               
            callback: this.randomShining,
            callbackScope: this,
            loop: true
        });
    }

    randomShining() {
        let actualArray = this.shiningPos['landscape'];

        if(this.orientationIsSetToPortrait()) {
            actualArray = this.shiningPos['portrait'];
        }

        const coor = actualArray[Math.floor(Math.random() * actualArray.length)];

        let shine = this.add.sprite(coor.x, coor.y, 'spark').setOrigin(0.5, 0.5);
        this.shiningContainer.add(shine);
        shine.setScale(0);

        this.tweens.add({
            targets: [shine],
            scale: Phaser.Math.RND.realInRange(0.3, 0.6),
            ease: ['Power0','Back'][Math.floor(Math.random() * 2)],
            yoyo: true,
            duration: Phaser.Math.Between(500, 800),
            onComplete: () => {
                shine.destroy();
            },
        });
    }

    addGameLogo() {
        this.logo = this.add.sprite(0, 0, 'logo').setOrigin(0.5, 0.5);

        this.anims.create({
            key: 'logo',
            frameRate: 20,
            yoyo: 0,
            repeat: -1,
            repeatDelay: 3000,
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('logo', {
                start: 0,
                end: 0,
            }),
        });

        this.anims.play('logo', this.logo);
    }

    afterSpin() {
        this.request.step();
    }

    addSymbolsAnimations() {
        for(const [ reelIndex, reel ] of Object.entries(this.slots.reelsContainersObjects)) {
            for(const symbolIndex of Object.keys(reel.symbols)) {
                let symbol = reel.symbols[symbolIndex];
            
                var config = {
                    key: `${symbol.texture.key}`,
                    skipMissedFrames: true,
                    frames: this.anims.generateFrameNumbers(`${symbol.texture.key}`, {
                        start: 0,
                        end: 24,
                    }),
                    frameRate: 20,
                    yoyo: 0,
                    repeat: 0
                };
                this.anims.create(config);
                symbol.anims.load(`${symbol.texture.key}`);
            }
        }
    }

    showWinning(text, callback) {
        let win = 'Mega';

        if(!text) {
            var winningAmount = this.request.scenario.amount_won;

            if(!winningAmount) {
                this.winning.playPaylines();

                if(callback) {
                    callback();
                }

                return;
            }

            win = 'Regular';

            if(this.request.scenario.tags.big_win) {
                win = 'Big';
            }
        }

        this.prepareWinningContainer(win);

        this.winning.playPaylines();

        if(callback) {
            callback();
        }
    }

    customPaylineSound(symbolObject) {
        if(symbolObject.symbolName === 'scatter') {
            this.sound.play('Mega');
        } else {
            this.playWinlineSound();
        }
    }

    customStopAnimation(reelIndex) {
        this.sound.play('reel_stop');
    }

    winningOnPayline(payline, match) {
        this.destroyWinningOnPayline();

        if(match.type !== 'row') {
            return;
        }

        const symbol = this.slots.getSymbolOnReelPosition(3, payline.midPosition)

        let winning = General.format_currency(match.multiplier * Config.current_amount.amount).replace(Config.currency.symbol, '');

        let amountContainer = this.winning.createWinningFromSprites(winning, 0.4);

        amountContainer.x = symbol.x;
        amountContainer.y = symbol.y;

        amountContainer.name = 'win_amount';
        amountContainer.setScale(0);

        this.slots.reelsContainer.add(amountContainer);
        
        amountContainer.tween = this.tweens.add({
            targets: [amountContainer],
            scale: 1,
            ease: 'Back',
            duration: 300
        });
    }

    destroyWinningOnPayline() {
        let winAmount = this.slots.reelsContainer.getByName('win_amount');

        if(winAmount) {
            winAmount.destroy();
        }
    }

    prepareWinningContainer() {
        this.hideWinTable();

        this.winningsContainer.alpha = 0;
    }

    hideWinTable() {
        if(this.winningsContainer && this.winningsContainer.alpha) {
            if(this.winningsContainer.tween && this.winningsContainer.tween.isPlaying()) {
                this.winningsContainer.tween.stop();
                this.winningsContainer.tween.remove();
            }
        
            this.winningsContainer.alpha = 0;

            for(const [symbolIndex, sprite] of Object.entries(this.winningsContainer.getAll())) {
                if(sprite.tween && sprite.tween.isPlaying()) {
                    sprite.tween.stop();
                    sprite.tween.remove();
                }
            }
        }
    }

    drawPaylines() {
        const halfSymbolHeight = this.slots.symbolHeight / 2;
        const offsetY = this.slots.frame.y;
        const x = this.slots.frame.x - this.slots.frameLeftOffset - 1;

        this.payline.paylines[1] = this.add.sprite(x, offsetY, 'payline_01_02_03').setOrigin(0.5, 0.5);
        this.payline.paylines[1].midPosition = 1;
        this.payline.paylines[2] = this.add.sprite(x, offsetY - this.slots.symbolHeight, 'payline_01_02_03').setOrigin(0.5, 0.5);
        this.payline.paylines[2].midPosition = 0;
        this.payline.paylines[3] = this.add.sprite(x, offsetY + this.slots.symbolHeight, 'payline_01_02_03').setOrigin(0.5, 0.5);
        this.payline.paylines[3].midPosition = 2;
        this.payline.paylines[4] = this.add.sprite(x, offsetY, 'payline_04').setOrigin(0.5, 0.5);
        this.payline.paylines[4].midPosition = 2;
        this.payline.paylines[5] = this.add.sprite(x, offsetY, 'payline_05').setOrigin(0.5, 0.5);
        this.payline.paylines[5].midPosition = 0;
        this.payline.paylines[6] = this.add.sprite(x, offsetY + halfSymbolHeight, 'payline_06_09').setOrigin(0.5, 0.5);
        this.payline.paylines[6].midPosition = 2;
        this.payline.paylines[7] = this.add.sprite(x, offsetY - halfSymbolHeight, 'payline_07_08').setOrigin(0.5, 0.5);
        this.payline.paylines[7].midPosition = 0;
        this.payline.paylines[8] = this.add.sprite(x, offsetY + halfSymbolHeight, 'payline_07_08').setOrigin(0.5, 0.5);
        this.payline.paylines[8].midPosition = 1;
        this.payline.paylines[9] = this.add.sprite(x, offsetY - halfSymbolHeight, 'payline_06_09').setOrigin(0.5, 0.5);
        this.payline.paylines[9].midPosition = 1;
        this.payline.paylines[10] = this.add.sprite(x, offsetY - halfSymbolHeight, 'payline_10_18').setOrigin(0.5, 0.5);
        this.payline.paylines[10].midPosition = 1;
        this.payline.paylines[11] = this.add.sprite(x, offsetY + halfSymbolHeight, 'payline_11_19').setOrigin(0.5, 0.5);
        this.payline.paylines[11].midPosition = 1;
        this.payline.paylines[12] = this.add.sprite(x, offsetY, 'payline_12').setOrigin(0.5, 0.5);
        this.payline.paylines[12].midPosition = 0;
        this.payline.paylines[13] = this.add.sprite(x, offsetY, 'payline_13').setOrigin(0.5, 0.5);
        this.payline.paylines[13].midPosition = 2;
        this.payline.paylines[14] = this.add.sprite(x, offsetY - halfSymbolHeight, 'payline_14_21').setOrigin(0.5, 0.5);
        this.payline.paylines[14].midPosition = 0;
        this.payline.paylines[15] = this.add.sprite(x, offsetY + halfSymbolHeight, 'payline_15_20').setOrigin(0.5, 0.5);
        this.payline.paylines[15].midPosition = 2;
        this.payline.paylines[16] = this.add.sprite(x, offsetY, 'payline_16').setOrigin(0.5, 0.5);
        this.payline.paylines[16].midPosition = 0;
        this.payline.paylines[17] = this.add.sprite(x, offsetY, 'payline_17').setOrigin(0.5, 0.5);
        this.payline.paylines[17].midPosition = 2;
        this.payline.paylines[18] = this.add.sprite(x, offsetY + halfSymbolHeight, 'payline_10_18').setOrigin(0.5, 0.5);
        this.payline.paylines[18].midPosition = 2;
        this.payline.paylines[19] = this.add.sprite(x, offsetY - halfSymbolHeight, 'payline_11_19').setOrigin(0.5, 0.5);
        this.payline.paylines[19].midPosition = 0;
        this.payline.paylines[20] = this.add.sprite(x, offsetY - halfSymbolHeight, 'payline_15_20').setOrigin(0.5, 0.5);
        this.payline.paylines[20].midPosition = 1;
        this.payline.paylines[21] = this.add.sprite(x, offsetY + halfSymbolHeight, 'payline_14_21').setOrigin(0.5, 0.5);
        this.payline.paylines[21].midPosition = 1;
        this.payline.paylines[22] = this.add.sprite(x, offsetY, 'payline_22').setOrigin(0.5, 0.5);
        this.payline.paylines[22].midPosition = 2;
        this.payline.paylines[23] = this.add.sprite(x, offsetY, 'payline_23').setOrigin(0.5, 0.5);
        this.payline.paylines[23].midPosition = 0;
        this.payline.paylines[24] = this.add.sprite(x, offsetY, 'payline_24').setOrigin(0.5, 0.5);
        this.payline.paylines[24].midPosition = 1;
        this.payline.paylines[25] = this.add.sprite(x, offsetY, 'payline_25').setOrigin(0.5, 0.5);
        this.payline.paylines[25].midPosition = 1;
        
        for(const [ paylineIndex, payline ] of Object.entries(this.payline.paylines)) {
            payline.name = `payline_${paylineIndex}`;
            this.payline.paylinesContainer.add(payline);
            this.slots.reelsContainer.add(payline);
        }

        this.payline.paylinesContainer.y = this.slots.reelsOffsetTop;
        this.payline.hidePaylines();
    }

    playSpinSound() {
        this.spinSound.play();
    }

    muteSpinSound() {
        this.spinSound.stop();
    }

    playStopSound() {
        this.sound.play('click', {"volume":0.4});
    }

    playWinlineSound() {
        this.sound.play('gem');
    }

    skipAnimations() {
        this.winning.removeTimers();
        this.hideWinTable();
        this.skip = true;
        this.winning.doCallback();
    }
    
    overspinAnimation(overspinReel) {
        let overspin = this.add.sprite(overspinReel.x, overspinReel.y - 30, 'overspin').setOrigin(0.5, 0.5);

        var config = {
            key: `${overspin.texture.key}`,
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers(`${overspin.texture.key}`, {
                start: 0,
                end: 19,
            }),
            frameRate: 26,
            yoyo: 0,
            repeat: -1
        };

        this.anims.create(config);

        overspin.anims.load(`${overspin.texture.key}`);
        overspin.play(`${overspin.texture.key}`);

        return overspin;
    }

    symbolsFader() {
        const fader = this.slots.reelsContainer.getByName(this.slots.symbolsFade);
        fader.alpha = 1;
        this.slots.reelsContainer.bringToTop(fader);
    }

    destroySymbolsFader() {
        this.slots.reelsContainer.getByName(this.slots.symbolsFade).alpha = 0;
    }

    gamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        this.logo.x = this.slots.frame.x + this.cameras.main.centerX;
        this.logo.y = 95 + this.slots.frameTopOffset;

        this.slots.frameMaskHeight = 470;
        let offsetX = 0;

        if(this.orientationIsSetToPortrait()) {
            this.bg.setTexture('bg_portrait');
            this.torch.alpha = 0;

        } else {
            this.torch.alpha = 1;
            this.bg.setTexture('bg');
        }


        this.slots.createReelsMask(offsetX);
    }
}

startGame(GameScene);